import useProduct from "../hooks/useProduct";
import { createContext, useState } from "react";
import clienteAxios from "../config/clienteAxios";
const BuscadorContext = createContext();

const BuscadorProvider = ({ children }) => {
  const [busqueda, setBusqueda] = useState(null);
  const [busquedaSuggestion, setBusquedaSuggestion] = useState(null);
  const [resultadosBusqueda, setResultadosBusqueda] = useState(null);
  const [suggestions, setSuggestions] = useState([]);
  const [totalSearchResult, setTotalSearchResult] = useState(0);
  const { products } = useProduct();

  const arrayProductos = products?.filter(
    (prod) => prod?.deleted === false && prod?.visible === true && prod
  );

  const removeAccents = (str) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };

  const HandleSearch = async () => {
    setResultadosBusqueda("");
    try {
      const { data } = await clienteAxios.post(`multisearch`, {
        search: removeAccents(busqueda.search),
      });
      setResultadosBusqueda(data.results);
      countTotalResults(data.results);
    } catch (err) {
      console.log(err);
    }
  };

  const countTotalResults = (dataToCount) => {
    let totalProducts =
      dataToCount?.products.length > 0 ? dataToCount.products.length : 0;

    const filteredSubProducts =
      arrayProductos?.length > 0
        ? dataToCount?.subProducts.filter((subProd) => {
            return arrayProductos?.some(
              (prod) => prod?._id === subProd?.productId
            );
          })
        : [];

    let totalSubProducts =
      filteredSubProducts?.length > 0 ? filteredSubProducts.length : 0;
    let totalNews = dataToCount?.news.length > 0 ? dataToCount.news.length : 0;
    let totalFaqs = dataToCount?.faqs.length > 0 ? dataToCount.faqs.length : 0;
    let totalBusiness =
      dataToCount?.business.length > 0 ? dataToCount.business.length : 0;
    let totalInTheWorld =
      dataToCount?.inTheWorld.length > 0 ? dataToCount.inTheWorld.length : 0;

    setTotalSearchResult(
      totalProducts +
        totalSubProducts +
        totalNews +
        totalFaqs +
        totalBusiness +
        totalInTheWorld
    );
  };

  return (
    <BuscadorContext.Provider
      value={{
        busqueda,
        setBusqueda,
        HandleSearch,
        resultadosBusqueda,
        totalSearchResult,
        setTotalSearchResult,
        suggestions,
        setSuggestions,
        setBusquedaSuggestion,
        busquedaSuggestion,
      }}
    >
      {children}
    </BuscadorContext.Provider>
  );
};

export { BuscadorProvider };

export default BuscadorContext;
